export default __webpack_public_path__ + "static/media/code3.f3625fd2.png";